import { Box, Stack, Text } from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_EVENT } from "@raiden/library/constants/posts";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUrl from "@raiden/library/libraries/utils/generateApiUrl";
import { FormattedMessage } from "react-intl";
import { PostViewSuggestions } from "../../../../Posts/Common/View/suggestions";

export function Events() {
  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Post").Post[]>} */
  const { swrResponse: swrResponsePosts } = useApi(
    generateApiUrl({
      id: "@api.posts.viewAny",
      query: {
        page: 1,
        per_page: 3,
        type: [POSTS_TYPE_VALUE_EVENT],
        fields: ["post.current_revision", "post.revision.cover", "post.files"],
      },
    }),
  );

  return (
    <Box>
      <Text variant="h3">
        <FormattedMessage defaultMessage="L'agenda" />
      </Text>

      <Stack mt=".5rem" spacing="0" gap=".5rem">
        <PostViewSuggestions
          swrResponsePosts={swrResponsePosts}
          type={POSTS_TYPE_VALUE_EVENT}
          cardMaxWidth="full"
        />
      </Stack>
    </Box>
  );
}
